// extracted by mini-css-extract-plugin
module.exports = {"BoxedItem":"boxedItem-module--BoxedItem--24kZf"};